import { APP_PERFORMANCE_TIMINGS } from './rum-timings';

let pendingHydrationDurationMs: number | undefined;
let hydrationTimingSentToDatadog = false;

export type HydrationTimingSender = (name: string, durationMs: number) => void;

export const flushPendingHydrationTiming = (send: HydrationTimingSender, rumReady: boolean) => {
    if (hydrationTimingSentToDatadog || pendingHydrationDurationMs === undefined || !rumReady) {
        return;
    }

    hydrationTimingSentToDatadog = true;
    send(APP_PERFORMANCE_TIMINGS.HYDRATION, pendingHydrationDurationMs);
    pendingHydrationDurationMs = undefined;
};

/**
 * Stores hydration duration until RUM is ready. Emits at most once per tab session
 * (not reset on SPA route change — unlike per-view `ddRumTimingOnce` names).
 */
export const reportHydrationMeasured = (durationMs: number, send: HydrationTimingSender, rumReady: boolean) => {
    if (hydrationTimingSentToDatadog || !Number.isFinite(durationMs) || durationMs < 0) {
        return;
    }

    pendingHydrationDurationMs = durationMs;
    flushPendingHydrationTiming(send, rumReady);
};

/** @internal Vitest only */
export const resetHydrationRumTimingStateForTests = () => {
    pendingHydrationDurationMs = undefined;
    hydrationTimingSentToDatadog = false;
};
